import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, DollarSign, TrendingUp, BarChart3 } from 'lucide-react';
import { Button } from '../../components/ui/Button';
export function LevelupInsurance() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="w-full pt-24 pb-24 bg-engage-black min-h-screen" data-id="element-271">
      <div className="max-w-6xl mx-auto px-4" data-id="element-272">
        {/* Back Link */}
        <Link to="/case-studies" className="inline-flex items-center text-engage-gray4 hover:text-engage-yellow transition-colors mb-12 font-medium" data-id="element-273">
          <ArrowLeft className="w-4 h-4 mr-2" data-id="element-274" />
          Back to Case Studies
        </Link>

        {/* Hero */}
        <div className="mb-16 max-w-4xl" data-id="element-275">
          <div className="flex flex-wrap gap-3 mb-6" data-id="element-276">
            <span className="px-4 py-1.5 bg-engage-yellow/10 text-engage-yellow border border-engage-yellow/20 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-277">
              Insurance
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-278">
              Scaling
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-279">
              Paid Search
            </span>
          </div>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-engage-white tracking-tight mb-4" data-id="element-280">
            Levelup Insurance
          </h1>
          <h2 className="text-2xl md:text-3xl text-engage-gray4 font-medium leading-tight" data-id="element-281">
            Scaling High-Quality Leads Nationwide
          </h2>
        </div>

        {/* Key Results Stats */}
        <div className="mb-16" data-id="element-282">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-283">
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-284">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-285">
                <DollarSign className="w-24 h-24 text-engage-yellow" data-id="element-286" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-287">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-288">
                  <DollarSign className="w-6 h-6 text-engage-yellow" data-id="element-289" />
                </div>
                <div data-id="element-290">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-291">
                    $70K
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-292">
                    Monthly Ad Spend
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-293">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-294">
                <TrendingUp className="w-24 h-24 text-engage-yellow" data-id="element-295" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-296">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-297">
                  <TrendingUp className="w-6 h-6 text-engage-yellow" data-id="element-298" />
                </div>
                <div data-id="element-299">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-300">
                    -45%
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-301">
                    Cost Per Lead
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-302">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-303">
                <BarChart3 className="w-24 h-24 text-engage-yellow" data-id="element-304" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-305">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-306">
                  <BarChart3 className="w-6 h-6 text-engage-yellow" data-id="element-307" />
                </div>
                <div data-id="element-308">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-309">
                    10x
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-310">
                    Volume Growth
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Content Sections */}
        <div className="space-y-10" data-id="element-311">
          {/* The Challenge */}
          <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-12" data-id="element-312">
            <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-313">
              The Challenge
            </h3>
            <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-314" />
            <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-315">
              Level Up had worked with multiple providers but struggled with
              inconsistent and low-quality leads that didn{'\u2019'}t convert.
              Scaling was limited by poor lead intent and lack of reliable
              systems, while bilingual communication added complexity. The
              challenge was to grow volume without sacrificing quality or
              conversion.
            </p>
          </div>

          {/* Our Approach & The Result */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-316">
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-317">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[radial-gradient(circle_at_top_right,rgba(252,198,13,0.12)_0%,transparent_70%)]" data-id="element-318" />
              <div className="relative z-10" data-id="element-319">
                <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-320">
                  Our Approach
                </h3>
                <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-321" />
                <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-322">
                  We built a bilingual acquisition system focused on trust,
                  clarity, and performance. Through native messaging,
                  high-converting creatives, and a structured funnel, we
                  attracted higher-intent prospects while maintaining
                  scalability. Continuous optimization ensured both efficiency
                  and consistent improvement.
                </p>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-323">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[radial-gradient(circle_at_top_right,rgba(252,198,13,0.12)_0%,transparent_70%)]" data-id="element-324" />
              <div className="relative z-10" data-id="element-325">
                <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-326">
                  The Result
                </h3>
                <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-327" />
                <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-328">
                  Level Up scaled aggressively while improving lead quality and
                  maintaining performance. The business expanded nationwide,
                  generated consistent lead flow, and established a reliable
                  system capable of supporting long-term growth.
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial */}
          <div className="bg-engage-gray1 border border-engage-gray2 p-10 md:p-16 lg:p-20 rounded-2xl relative overflow-hidden text-center" data-id="element-329">
            <div className="flex justify-center mb-8" data-id="element-330">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="text-engage-yellow" data-id="element-331">
                <path d="M14.017 21L16.411 14.182C16.411 14.182 15.045 14.182 15.045 10.773C15.045 7.36364 18.006 5 21 5C23.994 5 24 7.36364 24 7.36364C24 7.36364 22.634 7.36364 22.634 10.773C22.634 14.182 19.909 21 19.909 21H14.017ZM3.017 21L5.411 14.182C5.411 14.182 4.045 14.182 4.045 10.773C4.045 7.36364 7.006 5 10 5C12.994 5 13 7.36364 13 7.36364C13 7.36364 11.634 7.36364 11.634 10.773C11.634 14.182 8.909 21 8.909 21H3.017Z" data-id="element-332" />
              </svg>
            </div>
            <blockquote className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-medium italic text-engage-white mb-10 md:mb-12 leading-relaxed relative z-10 max-w-4xl mx-auto" data-id="element-333">
              We finally found a system that delivers the right leads{'\u2014'}
              consistently and at scale.
            </blockquote>
            <div className="flex flex-col items-center relative z-10" data-id="element-334">
              <img src="https://cdn.magicpatterns.com/uploads/2V6pxVhveoDPxpW8Zxr6BS/LevelUpInsurance-CS.png" alt="Level Up Insurance" className="w-16 h-16 md:w-20 md:h-20 rounded-full mb-4 border-2 border-engage-gray2 object-cover" data-id="element-335" />
              <div className="font-bold text-engage-white text-lg" data-id="element-336">
                Levelup Insurance Team
              </div>
              <div className="text-engage-yellow font-medium text-sm uppercase tracking-wider" data-id="element-337">
                CEO, Levelup Insurance
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-20 text-center bg-engage-gray1 border border-engage-gray2 rounded-2xl p-12 md:p-20 relative overflow-hidden" data-id="element-338">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(252,198,13,0.08)_0%,transparent_100%)]" data-id="element-339" />
          <div className="relative z-10 max-w-4xl mx-auto" data-id="element-340">
            <h2 className="text-3xl md:text-5xl font-black mb-6 tracking-tight" data-id="element-341">
              Ready to Build Your Growth Engine?
            </h2>
            <p className="text-engage-gray4 text-xl mb-10" data-id="element-342">
              Stop guessing with your marketing budget. Let's build a
              predictable system for your brand.
            </p>
            <Button to="/contact" variant="primary" className="text-lg px-12 py-5" data-id="element-343">
              Book a Call With Us
            </Button>
          </div>
        </div>
      </div>
    </div>;
}